import fetch from '../../fetch';
import { IHttpMethod } from '../../../ts/enums/fetch-enums';
import { ILoggedBusiness } from '../../../interfaces/i-logged-business';
import { ILoggedUser } from '../../../interfaces/i-logged-user';

const controllerName = 'auth';

const endpoints = {
  login: 'login',
  refresh: 'refresh',
};

export interface IAuthLogin {
  business?: string;
  login: string;
  password: string;
}

export interface IAuthSessionResponse {
  accessToken: string;
  refreshToken: string;
  user: ILoggedUser;
  business: ILoggedBusiness | null;
}

export async function authLogin(data: IAuthLogin) {
  return await fetch<IAuthSessionResponse>({
    method: IHttpMethod.POST,
    path: `${controllerName}/${endpoints.login}`,
    data,
  });
}

export async function refreshToken(refreshToken?: string) {
  const { data } = await fetch<IAuthSessionResponse>({
    method: IHttpMethod.POST,
    path: `${controllerName}/${endpoints.refresh}`,
    data: {
      refreshToken,
    },
  });

  return data;
}
